import Component, {mixins} from 'vue-class-component';
import {CartMixin} from '../../../Mixins';
import {Prop, Watch} from 'vue-property-decorator';
import Cross from '../../Icons/Cross.vue';
import Trash from '../../Icons/Trash.vue';
import Cart from '../../Icons/Cart.vue';
import Login from '../../Icons/Login.vue';
import Tickets from '../../Icons/Tickets.vue';
import {mapGetters} from 'vuex';
import {CustomerDataDTO, SessionDTO} from '../../../DTOs';
import {CLEAR_BUYER_DATA, CLEAR_IS_GUEST_ORDER, CLEAR_SESSION, CLEAR_USER, SET_BUYER_DATA, SET_USER} from '../../../store/commits';
import {AuthService} from '../../../Services';
import {User} from '../../../Models';
import MiniCartFaceliftIcon from '../../Icons/MiniCartFaceliftIcon.vue';
import ShoppingCartIcon from '../../Icons/ShoppingCartIcon.vue';

@Component({
  computed: {
    ...mapGetters({
      currentBuyerData: 'getBuyerData',
      sessionDTO: 'getSession',
      user: 'getUser',
    }),
  },
  components: {
    ShoppingCartIcon,
    MiniCartFaceliftIcon,
    Cross,
    Trash,
    Cart,
    Login,
    Tickets,
  },
})
export default class MiniCartView extends mixins(CartMixin) {
  @Prop({type: String, required: true}) cartUrl: string | undefined;
  @Prop({type: String, required: true}) loginUrl: string | undefined;
  @Prop({type: String, required: true}) shopUrl: string | undefined;
  @Prop({type: String, required: true}) loginSystemUrl: string | undefined;
  @Prop({type: [String, Boolean], required: true, default: false}) ticketNavItemState: Boolean | undefined;
  @Prop({type: [String, Boolean], required: true, default: false}) cartNavItemState: Boolean | undefined;
  @Prop({type: [String, Boolean], required: true, default: false}) loginNavItemState: Boolean | undefined;

  currentBuyerData: CustomerDataDTO | undefined;
  sessionDTO!: SessionDTO | null;
  user!: User | null;
  authService!: AuthService;

  private boxOpen: boolean = false;
  private miniCartContentIsOverflowingY: boolean = false;
  private isCartOpenFacelift = false;

  created() {
    this.authService = new AuthService(this.loginSystemUrl);
  }

  async mounted() {
    if (this.isAuthenticated && !this.loggedIn) {
      this.fetchUser();
    }
    this.checkIfMiniCartContentNeedsScrollBarY();
  }

  toggleBox() {
    this.boxOpen = !this.boxOpen;
  }

  checkIfMiniCartContentNeedsScrollBarY() {
    const miniCartContent = this.$refs.miniCart__content as HTMLElement;
    if (miniCartContent) {
      this.miniCartContentIsOverflowingY = miniCartContent.scrollHeight > miniCartContent.clientHeight;
    }
  }

  emptyCart() {
    this.deleteOrder();
  }

  toggleCartFacelift() {
    if (this.isFacelift) {
      if (this.isCartOpenFacelift) {
        this.closeCart();
      } else {
        this.openCart();
      }
    }
  }

  openCart() {
    const event = new CustomEvent('OpenMiniCart');
    window.dispatchEvent(event);
    this.isCartOpenFacelift = true;
  }

  closeCart() {
    const event = new CustomEvent('CloseMiniCart');
    window.dispatchEvent(event);
    this.isCartOpenFacelift = false;
  }

  async fetchUser() {
    if (this.isAuthenticated) {
      try {
        const user = await this.authService.fetchUserData(this.sessionDTO!.session!);
        this.$store.commit(SET_USER, user);
        const buyerData = (new CustomerDataDTO()).fromData(user);
        this.$store.commit(SET_BUYER_DATA, buyerData);
      } catch (e) {
        console.error(e);
        await this.logout();
      }
    }
  }

  get loggedIn(): boolean {
    return this.hasUser && this.isAuthenticated;
  }

  get isAuthenticated() {
    return this.sessionDTO !== undefined && this.sessionDTO !== null && Boolean(this.sessionDTO.session);
  }

  get hasBuyerData(): boolean {
    return Boolean(this.currentBuyerData);
  }

  get hasUser(): boolean {
    return Boolean(this.user);
  }

  get isGuest(): boolean {
    return Boolean(this.isGuestOrder);
  }

  get loginSystem(): string {
    if (this.loggedIn && !this.isGuest) {
      return this.loginSystemUrl || '';
    }
    return this.loginUrl || '';
  }

  get loginTitle(): string {
    if (this.loggedIn) {
      return <string>this.$t('shopNav.editProfile');
    }
    return <string>this.$t('global.links.toLogin');
  }

  get isTicketNavItemEnabled() {
    return Boolean(Number(this.ticketNavItemState));
  }

  get isCartNavItemEnabled() {
    return Boolean(Number(this.cartNavItemState));
  }

  get isLoginNavItemEnabled() {
    return Boolean(Number(this.loginNavItemState));
  }

  get isFacelift() {
    return document.querySelector('.new-header');
  }
  @Watch('cart')
  onCartChange(newVal, oldVal) {
    this.checkIfMiniCartContentNeedsScrollBarY();
  }

  async logout() {
    let success = true;
    if (!this.isGuestOrder && this.sessionDTO && this.sessionDTO.session) {
      success = await this.authService.logout(this.sessionDTO.session);
    }

    if (success) {
      this.emptyCart();
      this.$store.commit(CLEAR_SESSION);
      history.replaceState(null, document.title, window.location.pathname);
      if (!this.isGuestOrder) {
        this.showToast(<string>this.$t('toasts.logOutSuccess'));
      } else {
        this.showToast(<string>this.$t('toasts.guestDataRemoved'));
      }
    } else {
      this.showToast(<string>this.$t('toasts.logOutError'));
    }
  }
}
